Revolution.Module.extend({
    NAME: "mde.bk-tabs", // OBLIGATOIRE (reflète l'arborescence répertoire : /mde/main.js)

    initialize: function ($) {
        $('body').on('click', '.js-select-tabs li', this.activeTabs);
    },

    onWindowLoad: function (e) {

    },

    onWindowScroll: function (e) {

    },
    onWindowResize: function (e) {

    },
    activeTabs: function (e) {
        var $obj = $(e.currentTarget);
        var $ulTabs = $obj.parents('.js-select-tabs').find('li');
        var $contentTab = $obj.parents('.bk-tabs').find('.content-tab');
        var index = $obj.index();

        // switch using id not index
        var id = '#' + $obj.find('button').attr('aria-controls');


        $ulTabs.attr('aria-expanded', "false");

        if ($obj.hasClass('active')) {
            $obj.attr('aria-expanded', "true");
        } else {
            $ulTabs.find('button').removeClass('active');
            $obj.find('button').addClass('active');
        }

        $contentTab.removeClass('active');
        // $contentTab.eq(index).addClass('active');

        //add class active to the content-tab with similar id
        $('.bk-tabs .content-tab'+id+'').addClass('active')

    }
});
